/* eslint-disable class-methods-use-this */
// eslint-disable-next-line max-classes-per-file
class Cache {
  static instance = new Cache()

  _cache = new Map()

  has(key) {
    return this._cache.has(key)
  }

  get(key) {
    return this._cache.get(key)
  }

  set(key, value) {
    this._cache.set(key, value)
  }

  delete(key) {
    return this._cache.delete(key)
  }
}
class LocalStoreCache extends Cache {
  static instance = new LocalStoreCache()

  has(key) {
    return !!localStorage.getItem(key)
  }

  get(key) {
    return JSON.parse(localStorage.getItem(key))
  }

  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  }

  delete(key) {
    localStorage.removeItem(key)
  }
}
class SessionStoreCache extends Cache {
  static instance = new SessionStoreCache()

  has(key) {
    return !!sessionStorage.getItem(key)
  }

  get(key) {
    return JSON.parse(sessionStorage.getItem(key))
  }

  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  }

  delete(key) {
    sessionStorage.removeItem(key)
  }
}
class IndexedDBStoreCache extends Cache {
  static instance = new IndexedDBStoreCache()

  has(key) {
    return !!sessionStorage.getItem(key)
  }

  get(key) {
    return JSON.parse(sessionStorage.getItem(key))
  }

  set(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  }

  delete(key) {
    sessionStorage.removeItem(key)
  }
}
const cacheType = {
  localStorage: LocalStoreCache,
  sessionStorage: SessionStoreCache,
  indexeddb: IndexedDBStoreCache,
  memory: Cache,
}
/**
 * 获取cache 实例
 * @param {'localStorage'|'sessionStorage'|'indexeddb'|'memory'} type
 */
export default function cacheFactory(type) {
  return cacheType[type].instance
}
